import { Controller as BaseController } from '@hotwired/stimulus';
import { Chart, BarController, BarElement, CategoryScale, LinearScale } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

Chart.register(BarController, BarElement, CategoryScale, LinearScale, ChartDataLabels);

export default class Controller extends BaseController {
  static values = {
    notEvaluated: Array,
    preReaders: Array,
    beginners: Array,
    intermediary: Array,
    fluent: Array,
    chartId: String,
    totalStudents: Number,
  };

  static targets = ['badge'];

  connect() {
    this.selectedLevel = 'intermediary';
    this.chart = null;
    setTimeout(() => {
      this.initializeChart();
      this.updateSelectedBadge(); // Precisa chamar para garantir que apenas o correto fique selecionado
    }, 100); // Pequeno delay para garantir que o DOM está pronto
  }

  initializeChart() {
    const data = this.getDataForLevel(this.selectedLevel);
    const totalStudents = this.totalStudentsValue;
    const color = this.getColorForLevel(this.selectedLevel);
    const isMobile = screen.width < 640;
    const ctx = document.getElementById(this.chartIdValue);

    if (!ctx) {
      return;
    }

    const context = ctx.getContext('2d');

    if (this.chart) {
      this.chart.destroy();
    }

    // Converter valores absolutos para porcentagens para a altura das barras
    const percentageData =
      totalStudents > 0 ? data.map((value) => (value * 100) / totalStudents) : data;

    this.chart = new Chart(context, {
      type: 'bar',
      data: {
        labels: ['1º Bimestre', '2º Bimestre', '3º Bimestre', '4º Bimestre'],
        datasets: [
          {
            label: 'Porcentagem',
            data: percentageData,
            backgroundColor: [color, color, color, color],
            borderWidth: 0,
            borderRadius: 16,
          },
        ],
      },
      options: {
        aspectRatio: isMobile ? 1.2 : 640 / 195,
        maintainAspectRatio: false,
        responsive: true,
        barPercentage: 0.6,
        scales: {
          y: {
            display: false,
            max: 100, // Definir máximo como 100%
            min: 0,
          },
          x: {
            grid: {
              display: false,
            },
            ticks: {
              display: true,
              font: {
                size: 16,
                color: '#667085',
              },
            },
          },
        },
        plugins: {
          legend: {
            display: false,
          },
          datalabels: {
            display: false, // Desabilita os labels nas barras
          },
        },
      },
    });
  }

  getDataForLevel(level) {
    let data;
    switch (level) {
      case 'pre_readers':
        data = this.preReadersValue;
        break;
      case 'beginners':
        data = this.beginnersValue;
        break;
      case 'intermediary':
        data = this.intermediaryValue;
        break;
      case 'fluent':
        data = this.fluentValue;
        break;
      case 'not_evaluated':
        data = this.notEvaluatedValue;
        break;
      default:
        data = this.intermediaryValue;
    }

    // Parse JSON string to array if needed
    if (typeof data === 'string') {
      try {
        return JSON.parse(data);
      } catch (e) {
        return [0, 0, 0, 0];
      }
    }

    return data;
  }

  getColorForLevel(level) {
    const colors = {
      not_evaluated: '#D0D5DD',
      pre_readers: '#F97066',
      beginners: '#FEC84B',
      intermediary: '#6CE9A6',
      fluent: '#45B8FF',
    };
    return colors[level] || '#FEC84B';
  }

  selectBadge(event) {
    event.preventDefault();
    const badge = event.currentTarget;
    const level = badge.dataset.level;

    if (level !== this.selectedLevel) {
      this.selectedLevel = level;
      this.updateSelectedBadge();
      this.initializeChart();
    }
  }

  updateSelectedBadge() {
    const badges = this.element.querySelectorAll('[data-level]');
    badges.forEach((badge) => {
      const innerBadge = badge.querySelector('div');
      if (!innerBadge) return;

      const isSelected = badge.dataset.level === this.selectedLevel;

      if (isSelected) {
        innerBadge.style.backgroundColor = this.getColorForLevel(badge.dataset.level);
        innerBadge.classList.add('tw-text-coolGray-950', 'tw-border-0');
        innerBadge.classList.remove('tw-border-coolGray-400');
      } else {
        innerBadge.style.backgroundColor = '';
        innerBadge.classList.remove('tw-text-coolGray-950', 'tw-border-0');
        innerBadge.classList.add('tw-border-coolGray-400');
      }
    });
  }
}
